// Profile-related constants and validation messages

// Error message constants for profile validation
export const PROFILE_ERROR_MESSAGES = {
  NAME_REQUIRED: 'Name is required.',
  EMAIL_REQUIRED: 'Email is required.',
  EMAIL_INVALID: 'Please enter a valid email address.',
  PHONE_REQUIRED: 'Phone number is required.',
  PHONE_INVALID: 'Please enter a valid 10-digit phone number.',
  BUSINESS_NAME_REQUIRED: 'Business name is required.',
  BUSINESS_GSTINPAN_REQUIRED: 'GSTIN/PAN is required.',
  BUSINESS_GSTINPAN_INVALID: 'Enter a valid GSTIN (15 chars) or PAN (10 chars).',
  BUSINESS_ADDRESS_REQUIRED: 'Business address is required.',
  KYC_STATUS_REQUIRED: 'KYC status is required.',
};

// Friendly field labels (used for user-facing messages)
export const PROFILE_FIELD_LABELS = {
  name: 'Name',
  email: 'Email',
  phoneNumber: 'Phone number',
  userType: 'User type',
  businessName: 'Business name',
  businessGstinPan: 'Business GSTIN/PAN',
  businessAddress: 'Business address',
  kycStatus: 'KYC status',
};
